import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import * as Yup from 'yup';
import {
  Formik, Form as FormikForm,
} from 'formik';

import { Row, Col } from 'react-bootstrap';

import {
  TextField,
  TextAreaField,
  FileField,
  SelectFieldV2,
  CheckBoxField,
  SubmitButton,
  CancelPopupButton,
} from 'ui/FormElement';

import usePrompts from 'components/Admin/Prompts/Hooks/usePrompts';

export default function Form({ avatar, onSave, onClose }) {
  const { prompts } = usePrompts();

  const formSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    greeting: Yup.string().required('Greeting is required'),
    description: Yup.string().required('Description is required'),
  });

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    const onSuccess = () => {
      setSubmitting(false);
    };

    const onError = (errorData) => {
      const newErrors = {};
      errorData.errors.forEach((item) => {
        newErrors[item.source.replace('/data/attributes/', '')] = item.detail;
      });
      setErrors(newErrors);
      setSubmitting(false);
    };

    onSave(values, onSuccess, onError);
  };

  useEffect(() => {
    $('body').trigger('general:one_height');
  }, []);

  return (
    <Formik
      enableReinitialize
      validationSchema={formSchema}
      initialValues={avatar}
      onSubmit={onSubmit}
    >
      {({ isSubmitting, values }) => (
        <FormikForm className="needs-validation" noValidate="">
          <Row className="one-height">
            <Col md={6} className="one-row check">
              <div className="ibox-content top-green-line">
                <h2>General</h2>
                <TextField
                  name="name"
                  label={(
                    <>
                      <span>Name</span>
                      <abbr title="required">*</abbr>
                    </>
                  )}
                />
                <TextField
                  name="greeting"
                  label={(
                    <>
                      <span>Greeting</span>
                      <abbr title="required">*</abbr>
                    </>
                  )}
                />
                <TextAreaField
                  name="description"
                  label={(
                    <>
                      <span>Description</span>
                      <abbr title="required">*</abbr>
                    </>
                  )}
                />

                <CheckBoxField
                  name="is_public"
                  inline
                  label={(
                    <span>Website Avatar</span>
                  )}
                />

              </div>
            </Col>
            <Col md={6} className="one-row check">
              <div className="ibox-content top-green-line">
                <h2>HeyGen Config</h2>
                <TextField
                  name="heygen"
                  label={(
                    <span>Avatar ID</span>
                  )}
                />
                <h2>AWS Bedrock Config</h2>
                <div>
                  <CheckBoxField
                    name="is_inline"
                    inline
                    label={(
                      <span>Inline Avatar</span>
                    )}
                  />
                </div>

                {!values.is_inline && (
                  <>
                    <TextField
                      name="bedrock_agent"
                      label={(
                        <span>Bedrock Agent ID</span>
                      )}
                    />
                    <TextField
                      name="bedrock_alias"
                      label={(
                        <span>Bedrock Alias ID</span>
                      )}
                    />
                  </>
                )}
              </div>
            </Col>
          </Row>
          <Row className="one-height mt20">
            <Col md={6} className="one-row check">
              <div className="ibox-content top-green-line">
                <h2>Video Avatar Preview</h2>

                <FileField
                  name="preview_image"
                  label={(
                    <span>Image</span>
                  )}
                />

                {avatar.preview_image_url && (
                  <div className="mb10" style={{ marginTop: '-10px' }}>
                    Currently uploaded file:
                    <div className="file-input-wrapper fix-size">
                      <img src={avatar.preview_image_url} alt="preview" />
                    </div>
                  </div>
                )}

              </div>
            </Col>
            <Col md={6} className="one-row check">
              <div className="ibox-content top-green-line">
                <h2>Prompts</h2>

                <SelectFieldV2
                  name="prompt_ids"
                  placeholder="Choose Prompts"
                  isMulti
                  options={prompts ? prompts.map((prompt) => ({
                    value: prompt.id,
                    label: prompt.attributes.message,
                  })) : []}
                  label={(
                    <span>Prompts</span>
                  )}
                />

              </div>
            </Col>
          </Row>

          <Row className="mt50 mb30 text-right">

            <CancelPopupButton
              className="btn btn-primary btn-outline mr5 ml5 width-120"
              title="Cancel"
              onClick={onClose}
            />
            <SubmitButton
              title={isSubmitting ? 'Please, wait ...' : 'Save'}
              className={`btn width-120 btn-primary submit-button mr5 ml5 ${isSubmitting ? 'not-possible-click' : ''
                }`}
            />

          </Row>
        </FormikForm>
      )}
    </Formik>
  );
}

Form.propTypes = {
  avatar: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
